import { useState, useEffect } from "react";
import Badge from "../../../../../components/Badge/Badge";
import { handleToast } from "../../../../../helper";

export default function ReferrerSites(props) {
  const { referrerSitesData, customizeState, setCustomizeState, nudgeData } =
    props;
  const [referrerSites, setReferrerSites] = useState(referrerSitesData);

  useEffect(() => {
    if (nudgeData) {
      const referrerSites = nudgeData?.nudgeTrafficSources?.customizeProperties?.referrerSites || [];

      if (referrerSites) {
        let tempReferrers = referrerSites?.propertyValue?.length;
        if (tempReferrers) {
          setReferrerSites(referrerSites.propertyValue);
        }
      }
    }
  }, [nudgeData]);

  useEffect(() => {
    let state = {
      ...customizeState,
      nudgeTrafficSources: {
        ...customizeState["nudgeTrafficSources"],
        referrerSites,
      },
    };
    setCustomizeState(state);
  }, [referrerSites]);

  function handleDeleteReferrer(title) {
    // remove referrer
    const newReferrerSites = referrerSites.filter(
      (referrerSite) => referrerSite !== title
    );
    setReferrerSites(newReferrerSites);
  }

  return (
    <div className="p-4 space-y-3">
      <h3 className="text-lg font-bold">Referrer Site URLs: </h3>
      <div className="">
        {referrerSites?.length > 0 ? (
          <div className="my-1 flex flex-wrap gap-3 max-w-5xl">
            {referrerSites?.map((referrerSite, index) => {
              if (referrerSite === "HandleEmptyArrayValue") return null;
              return (
                <Badge
                  key={referrerSite}
                  title={referrerSite}
                  onClose={handleDeleteReferrer}
                  index={index}
                />
              )
              
            })}
          </div>
        ) : null}
      </div>
      <InputBadge
        referrerSites={referrerSites}
        setReferrerSites={setReferrerSites}
      />
    </div>
  );
}

function InputBadge({ referrerSites, setReferrerSites }) {
  const [title, setTitle] = useState("");

  async function handleSaveReferrer() {
    // check for duplicate
    if (referrerSites.includes(title)) {
      handleToast("error", "Duplicate referrer site");
      return;
    }
    // check for empty
    if (title === "") {
      handleToast("error", "Referrer site cannot be empty");
      return;
    }
    setReferrerSites((prev) => [...prev, title]);

    setTitle("");
  }

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSaveReferrer();
    }
  };

  return (
    <div className="Badge px-4 py-3 flex flex-col sm:flex-row gap-3 lg:gap-5 items-center rounded-md border-2 bg-opacity-5 border-indigo-500 bg-indigo-500 text-indigo-500">
      <input
        onKeyDown={handleKeyPress}
        onChange={(e) => setTitle(e.target.value)}
        className="text-md font-semibold outline-none rounded-lg bg-transparent border-r border-inherit flex-grow"
        placeholder="site.com (enter referrer site domain)"
        value={title}
      />
      <button
        className="px-4 py-1.5 text-lg text-white bg-indigo-500 rounded-md cursor-pointer"
        onClick={handleSaveReferrer}
      >
        Add
      </button>
    </div>
  );
}
